module.exports = __webpack_public_path__ + "static/media/morning.f2576850.svg";